module.exports = __webpack_public_path__ + "static/media/75.6e604896.jpg";